/**
 * Dev-Karten für die Werkstatt-Glass-Box-Reviews.
 *
 * Typ-Branch-Baseline (2026-06-08): Die zwei Karten testen den manuellen
 * Dokumenttyp-Branch (Stundenliste → timesheets, Diäten → expenses). Beide im
 * Junk-Monat 1981-09 hochgeladen (sichtbar als Test, kollidiert nie mit
 * Echtdaten, kein chirurgisches Cleanup nötig). Quelle: testdata/Std. Liste
 * Karl-Heinz (Stundenliste) + ocr/samples/expense/* (Diäten), beim Upload je
 * mit explizitem doc_type geroutet. (Frühere Rotations-Demos abgelöst.)
 *
 * Der Selector im WerkstattBranchHeader rendert sie als kleine Quick-Access-
 * Links. Die IDs hier sind keine API-Verträge — nur UX-Convenience.
 */

export interface DevCard {
  kind: "timesheet" | "expense";
  /** Card-UUID. Muss im aktuellen DB-Bestand vorhanden sein. */
  id: string;
  /** Anzeige-Label (kurz, ~10 Zeichen). */
  label: string;
  /** Optional: kurze Erläuterung im title-Tooltip. */
  hint?: string;
}

/** True wenn die Karte eine Dev/Demo-Karte ist (für den destruktiven Reset freigegeben). */
export function isDevCard(id: string | undefined | null): boolean {
  return !!id && DEV_CARDS.some((c) => c.id === id);
}

export const DEV_CARDS: DevCard[] = [
  {
    kind: "timesheet",
    id: "46002765-656c-406f-8b9a-28c60cf7a265",
    label: "🕐 Stundenliste",
    hint: "Test-Karte (Monat 1981-09, Std. Liste Karl-Heinz). Beim Upload manuell "
      + "als Stundenliste gewählt → direkt in timesheets geroutet. Baseline für den "
      + "Typ-Branch (Stundenlisten-Weg).",
  },
  {
    kind: "expense",
    id: "e981efd4-0792-4c64-94c2-93a3650b1232",
    label: "🧾 Diäten",
    hint: "Test-Karte (Monat 1981-09, Diäten-Sample). Beim Upload manuell als "
      + "Diäten gewählt → direkt in expenses geroutet. Baseline für den Typ-Branch "
      + "(Diäten-Weg). Orientierung: 0° (aufrecht).",
  },
  // Orientierungs-Set fürs räumliche Diäten-Modell (2026-06-09): echte verdrehte
  // Scans aus Nextcloud (Std-Listen 02_2026 Teil 2, Seiten 10+17 — beide kommen
  // 90° links gedreht) + synthetisch fehlende Orientierungen (Rotation in Pixel
  // gebacken, wie ein echter Scan). Zusammen mit der 0°-Baseline oben sind alle
  // 4 Orientierungen abgedeckt.
  {
    kind: "expense",
    id: "13be195b-c731-4524-88ed-bfee2d2cae0c",
    label: "🧾 90°⟲ S10",
    hint: "Echter Scan, 90° links (CCW) gedreht (Std-Listen 02_2026 T2 S10, "
      + "Monat 1981-09). Dienstnehmer: Osmankić Omer.",
  },
  {
    kind: "expense",
    id: "7a3e6378-5c8c-4eb0-bdff-0474e0bde673",
    label: "🧾 90°⟲ S17",
    hint: "Echter Scan, 90° links (CCW) gedreht (Std-Listen 02_2026 T2 S17, "
      + "Monat 1981-09). Dienstnehmer: Pöltl Christian.",
  },
  {
    kind: "expense",
    id: "acbe06c1-e298-49aa-bc18-f5018cac0324",
    label: "🧾 180°",
    hint: "Synthetisch: S17 um weitere 90° gedreht → 180° (kopfüber), Rotation "
      + "in Pixel gebacken (Monat 1981-09).",
  },
  {
    kind: "expense",
    id: "a7273da7-36c3-4f72-bbe7-b78de23d391c",
    label: "🧾 90°⟳",
    hint: "Synthetisch: S10 um 180° weitergedreht → 90° rechts (CW), Rotation "
      + "in Pixel gebacken (Monat 1981-09).",
  },
];
